function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect } from 'react';
import { toPairs, includes } from 'lodash';
import { useConfigAtomValues, useDataAtomValues, useStateAtomValues } from '../state';
import { EBillStatus } from '../constants';
import { Severity } from '@sentry/react';
import { useDebounceFn } from 'ahooks';
var billStatusMap = toPairs(EBillStatus).reduce(function (buffer, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  buffer[key] = value;
  return buffer;
}, {});

// disabled支付入口，包括支付方式卡片组件、支付按钮组件
export default function useDisabledPay() {
  var _useConfigAtomValues = useConfigAtomValues(),
    billStatusProps = _useConfigAtomValues.billStatusProps;
  var _useDataAtomValues = useDataAtomValues(),
    isBillPending = _useDataAtomValues.isBillPending,
    billStatus = _useDataAtomValues.billStatus,
    canPay = _useDataAtomValues.canPay;
  var _useStateAtomValues = useStateAtomValues(),
    notCanPayUpgradeSubBill = _useStateAtomValues.notCanPayUpgradeSubBill;

  // 当账单为已取消或已成功支付、或正在支付中时，账单不可支付
  var disabledPay = React.useMemo(function () {
    var pendingEnum = isBillPending ? EBillStatus.PENDING : null;
    var expiredEnum = notCanPayUpgradeSubBill ? EBillStatus.EXPIRED : null;
    var status = [EBillStatus.PAYED, EBillStatus.CANCELED, EBillStatus.PENDING, EBillStatus.EXPIRED];
    if (billStatusProps !== null && billStatusProps !== void 0 && billStatusProps.disabledPay) {
      status = billStatusProps.disabledPay(billStatusMap);
    }
    if (typeof status === 'boolean') return status;
    if (canPay) {
      return false;
    }
    return includes(status, billStatus) || includes(status, pendingEnum) || includes(status, expiredEnum);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billStatus, isBillPending, billStatusProps === null || billStatusProps === void 0 ? void 0 : billStatusProps.disabledPay, notCanPayUpgradeSubBill]);
  return disabledPay;
}
var REPORT_INTERVAL = 2000;

/** 禁用支付上报相关信息 */
export function useDisabledPayReport(module, disabledPay, sentryHub) {
  var _useConfigAtomValues2 = useConfigAtomValues(),
    hub = _useConfigAtomValues2.sentryHub,
    env = _useConfigAtomValues2.env,
    billStatusProps = _useConfigAtomValues2.billStatusProps;
  var _useDataAtomValues2 = useDataAtomValues(),
    billStatus = _useDataAtomValues2.billStatus,
    canPay = _useDataAtomValues2.canPay;
  var innerHub = sentryHub || hub;
  var _useDebounceFn = useDebounceFn(function () {
      var formattedDisablePayResult = '';
      if (billStatusProps !== null && billStatusProps !== void 0 && billStatusProps.disabledPay) {
        var disablePayResult = billStatusProps.disabledPay(billStatusMap);
        try {
          formattedDisablePayResult = Array.isArray(disablePayResult) ? JSON.stringify(disablePayResult) : disablePayResult;
        } catch (err) {}
      }
      var reportPayload = {
        disabledPay: disabledPay,
        canPay: canPay,
        billStatus: billStatus,
        disablePayResult: formattedDisablePayResult
      };
      innerHub.captureMessage(module + '禁用支付开启', Severity.Info, {
        captureContext: {
          tags: reportPayload,
          extra: reportPayload
        }
      });
    }, {
      wait: REPORT_INTERVAL
    }),
    report = _useDebounceFn.run;
  useEffect(function () {
    if (disabledPay) {
      if (env === 'prod') {
        report();
      }
    }
  }, [disabledPay, env, report]);
}